define([
	"dojo/_base/declare",
	"csi/form/Widget"
], function(declare, Widget) {

	return declare(Widget, {
		_parentType: null,

		_resolveView() {
			this._parentType = this._getParentTypeOfClientNode();
			this.inherited(arguments);
		},

		_updateFieldVisibility(/*Field?*/field) {
			const isTwoDim = this.defView.getFieldValue("IsTwoDim");
			this.setFieldHidden("DimensionType", isTwoDim);
			this.setFieldHidden("SizeCode", isTwoDim);
			this.setFieldHidden("Dimension1Size", !isTwoDim);
			this.setFieldHidden("Dimension2Size", !isTwoDim);

			if (!field && (this._parentType == "Material")) {
				this.setFieldHidden("IsTwoDim", true); // hide 2-dim field for Material
			}
		}
	});
});
